import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
// Component for wallet actions switches
function WalletActionsSwitches({ wallet }) {
  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingFrozen, setLoadingFrozen] = useState(false);
  const [loadingClosed, setLoadingClosed] = useState(false);
  const token = localStorage.getItem("user-token");
  // Local state for wallet status
  const [localStatus, setLocalStatus] = useState(wallet.status);

  // Helper to show Swal
  const showSwal = (type, title, text) => {
    Swal.fire({
      icon: type,
      title,
      text,
      timer: 2000,
      showConfirmButton: false,
    });
  };

  // Helper to show loading Swal
  const showLoadingSwal = (message) => {
    Swal.fire({
      title: message,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  };

  // Handlers for each switch
  const handleToggleActive = async () => {
    setLoadingActive(true);
    showLoadingSwal("جاري تحديث حالة التنشيط...");
    try {
      const res = await axios.get(
        `${BASE_URL}/administrator/wallets/active/${wallet.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLocalStatus(localStatus === "active" ? "inactive" : "active");
      Swal.close();
      showSwal("success", "تمت العملية بنجاح", "تم تحديث حالة التنشيط بنجاح");
    } catch (err) {
      Swal.close();
      showSwal("error", "حدث خطأ", "فشل تحديث حالة التنشيط");
    } finally {
      setLoadingActive(false);
    }
  };
  const handleToggleFrozen = async () => {
    setLoadingFrozen(true);
    showLoadingSwal("جاري تحديث حالة التجميد...");
    try {
      const res = await axios.get(
        `${BASE_URL}/administrator/wallets/frozen/${wallet.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLocalStatus(localStatus === "frozen" ? "active" : "frozen");
      Swal.close();
      showSwal("success", "تمت العملية بنجاح", "تم تحديث حالة التجميد بنجاح");
    } catch (err) {
      Swal.close();
      showSwal("error", "حدث خطأ", "فشل تحديث حالة التجميد");
    } finally {
      setLoadingFrozen(false);
    }
  };
  const handleToggleClosed = async () => {
    setLoadingClosed(true);
    showLoadingSwal("جاري تحديث حالة الإغلاق...");
    try {
      const res = await axios.get(
        `${BASE_URL}/administrator/wallets/closed/${wallet.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLocalStatus(localStatus === "closed" ? "active" : "closed");
      Swal.close();
      showSwal("success", "تمت العملية بنجاح", "تم تحديث حالة الإغلاق بنجاح");
    } catch (err) {
      Swal.close();
      showSwal("error", "حدث خطأ", "فشل تحديث حالة الإغلاق");
    } finally {
      setLoadingClosed(false);
    }
  };

  return (
    <MDBox display="flex" flexDirection="column" alignItems="center" gap={1}>
      <MDBox display="flex" alignItems="center" gap={0.5}>
        <MDTypography variant="caption">تنشيط</MDTypography>
        <CustomSwitch
          checked={localStatus === "active"}
          onChange={handleToggleActive}
          disabled={loadingActive}
        />
      </MDBox>
      <MDBox display="flex" alignItems="center" gap={0.5}>
        <MDTypography variant="caption">تجميد</MDTypography>
        <CustomSwitch
          checked={localStatus === "frozen"}
          onChange={handleToggleFrozen}
          disabled={loadingFrozen}
        />
      </MDBox>
      <MDBox display="flex" alignItems="center" gap={0.5}>
        <MDTypography variant="caption">إغلاق</MDTypography>
        <CustomSwitch
          checked={localStatus === "closed"}
          onChange={handleToggleClosed}
          disabled={loadingClosed}
        />
      </MDBox>
    </MDBox>
  );
}
export default function allWalletsTableData(wallets) {
  return {
    columns: [
      { Header: "رقم المحفظة", accessor: "id", align: "center" },
      { Header: "اسم صاحب المحفظة", accessor: "userName", align: "center" },
      { Header: "نوع صاحب المحفظة", accessor: "userType", align: "center" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "العملة", accessor: "currency", align: "center" },
      { Header: "الرصيد", accessor: "balance", align: "center" },
      { Header: "تاريخ الإنشاء", accessor: "createdAt", align: "center" },
      { Header: "الإجراءات", accessor: "actions", align: "center" },
    ],
    rows: wallets.map((wallet) => ({
      id: wallet.id,
      userName: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {wallet.user?.name || "-"}
        </MDTypography>
      ),
      userType: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {wallet.user?.type || "-"}
        </MDTypography>
      ),
      status: (
        <MDTypography
          variant="caption"
          color={wallet.status === "active" ? "success" : "error"}
          fontWeight="medium"
        >
          {wallet.status === "active" ? "نشطة" : "غير نشطة"}
        </MDTypography>
      ),
      currency: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {wallet.currency?.name || "-"}
        </MDTypography>
      ),
      balance: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {wallet.balance}
        </MDTypography>
      ),
      createdAt: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {wallet.created_at ? wallet.created_at.split("T")[0] : "-"}
        </MDTypography>
      ),
      actions: <WalletActionsSwitches wallet={wallet} />,
    })),
  };
}
